<mat-toolbar class="app-toolbar">
  <mat-toolbar-row>
    <div class="left">
      <button
        mat-button
        routerLink="/{{Const.URI_HOME}}"
        routerLinkActive="active"
        [routerLinkActiveOptions]="{exact: true}"
        class="menu-title">
        <span>OBiServer</span>
      </button>
    </div>
    <div class="right">
      <button
        mat-button
        routerLink="/{{Const.URI_ABOUT}}"
        routerLinkActive="active">
        <mat-icon>email</mat-icon>
        <div i18n>About</div>
      </button>
    </div>
    @if (!account) {
      <div class="right">
        <button
          mat-button
          routerLink="/{{Const.URI_AUTH}}/{{Const.URI_AUTH_LOGIN}}"
          routerLinkActive="active">
          <mat-icon>login</mat-icon>
          <div i18n>Login</div>
        </button>
      </div>
    } @else if (authIsNeed2fa()) {
      <div class="right">
        <button
          mat-button
          routerLink="/{{Const.URI_AUTH}}/{{Const.URI_AUTH_LOGOUT}}"
          routerLinkActive="active">
          <mat-icon>logout</mat-icon>
          <div i18n>Logout</div>
        </button>
      </div>
    } @else {
      <div class="right">
        @if (accountHasRole(RoleType.Admin)) {
          <button
            mat-button
            [matMenuTriggerFor]="adminMenu">
            <mat-icon>admin_panel_settings</mat-icon>
            <div i18n>Admin</div>
          </button>
          <mat-menu #adminMenu="matMenu">
            <button
              mat-menu-item
              routerLink="/{{Const.URI_ACCOUNT}}"
              routerLinkActive="active">
              <mat-icon>group</mat-icon>
              <div i18n>Accounts</div>
            </button>
            <button
              mat-menu-item
              routerLink="/{{Const.URI_CLIENT}}"
              routerLinkActive="active">
              <mat-icon>groups</mat-icon>
              <div i18n>Clients</div>
            </button>
          </mat-menu>
        }
        <client-picker></client-picker>
        <button
          mat-button
          [matMenuTriggerFor]="accountMenu">
          <mat-icon>person</mat-icon>
          <div>{{account.name}}</div>
        </button>
        <mat-menu #accountMenu="matMenu">
          <button
            mat-menu-item
            [matTooltip]="Tooltip.personal"
            matTooltipPosition="left"
            [attr.aria-label]="Tooltip.personal"
            routerLink="/{{Const.URI_AUTH}}/{{Const.URI_AUTH_PERSONAL}}"
            routerLinkActive="active">
            <mat-icon>settings</mat-icon>
            <div i18n>Settings</div>
          </button>
          <button
            mat-menu-item
            routerLink="/{{Const.URI_AUTH}}/{{Const.URI_AUTH_LOGOUT}}"
            routerLinkActive="active">
            <mat-icon>logout</mat-icon>
            <div i18n>Logout</div>
          </button>
        </mat-menu>
      </div>
    }
  </mat-toolbar-row>
</mat-toolbar>
